<template>
    <div>
        <br>
        <el-row :gutter="50" class="apps-container" justify="space-around" v-if="true">
            <el-col :span="12" v-for="(link) in links" :key="link.name">
                <div class="grid-content-apps">
                    <h3>
                        <router-link :to="link.route">
                            {{ link.name }}
                        </router-link>
                    </h3>
                    <p>{{ link.description }}</p>
                </div>
            </el-col>
        </el-row>
        <el-row v-if="infoUser.profile != 4 && infoUser.profile != 1 && links.length == 0">
            <label class="el-form--label-top">Se recomienda el uso de audífonos o dispositivos de audio externos.
                <i class="fas fa-volume-up"></i></label>
            <el-col :span="24">
                <video-player class="video-player-box"
                              ref="videoPlayer"
                              @ended="onPlayerEnded($event)"
                              :controlBar="false"
                              :options="playerOptions"
                              :playsinline="true"
                              customEventName="customstatechangedeventname">
                </video-player>
            </el-col>
        </el-row>
    </div>
</template>

<script>

export default {
    data() {
        return {
            links: [],
            showLinks: false,
            playerOptions: {
                // videojs options
                muted: true,
                language: 'en',
                playbackRates: [0.7, 1.0, 1.5, 2.0],
                sources: [{
                    type: "video/mp4",
                    src: "/storage/MSE proceso 27-08-21.MP4"
                }],
                poster: "/img/logo_sre.png",
            }
        }
    },
    computed: {
        infoUser() {
            return this.$store.state.user
        },
    },

    mounted() {
        this.validateVideos();
        this.$refs?.videoPlayer?.player?.controlBar?.progressControl?.disable();
    },

    methods: {
        validateVideos() {
            setTimeout(() => {
                if (this.infoUser.profile !== 4 && this.infoUser.profile != 1) {
                    let _userVideos = this.infoUser.videos?.filter(up => up.video_id == 1);
                    this.showLinks = _userVideos?.length > 0;
                    if (this.showLinks) {
                        axios.get('/api/links-home').then(response => {
                            this.links = response.data.links;
                        });
                    } else {
                        this.$message.info("Para continuar con su proceso de registro, es necesario visualzar el contenido que se muestra acontinuación.")
                    }
                } else {
                    axios.get('/api/links-home').then(response => {
                        this.links = response.data.links;
                    });
                }

            }, 3000)
        },

        onPlayerEnded(player) {
            if (player) {
                let _data = {
                    user: this.infoUser.id,
                    video: 1
                }
                axios.post('/api/user-video', _data).then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message);
                        this.showLinks = true;
                        axios.get('/api/links-home').then(response => {
                            this.links = response.data.links;
                        });
                    } else {
                        this.$message.error(response.data.message)
                    }
                }).catch(e => {
                    console.log("error ", e)
                })

            }
        }
    }
}
</script>
<style>
.card-home {
}

.apps-container {
    padding: 0 10px 0 30px;
}

.grid-content-apps a {
    color: #9D2449;
}
</style>
